import React from "react";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import Footer from "../Layout/Footer/Footer";
import MetaDecorator from "../Util/MetaDecorator";
import styles from "./Sfdr.module.scss";

export default function PAI() {
	return (
		<>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<MetaDecorator
				title={"PAI Statement | LRC Group"}
				description={
					"Statement on principal adverse impacts of investment decisions on sustainability factors"
				}
			/>
			<div className="long-container">
				<div className={styles.PAIStatement}>
					<h1>
						Statement on principal adverse impacts of investment decisions on
						sustainability factors
					</h1>
					<div className={styles.mainCard}>
						<p>
							Financial market participant - Storton Fund Management Ltd [LEI
							984500999A540457B545]
						</p>
						<h2>Summary</h2>
						<p>
							Storton Fund Management Ltd [LEI 984500999A540457B545] considers
							principal adverse impacts of its investment decisions on
							sustainability factors. The present statement is the consolidated
							statement on principal adverse impacts on sustainability factors
							of Storton Fund Management Ltd. This statement on principal
							adverse impacts on sustainability factors covers the reference
							period from <b>1 January 2023 to 31 December 2023.</b>
						</p>
						<p style={{ marginTop: "20px" }}>
							Storton Fund Management Ltd [LEI S84500SSSA540457B545]
							berücksichtigt die wichtigsten negativen Auswirkungen seiner
							Anlageentscheidungen auf Nachhaltigkeitsfaktoren. Die vorliegende
							Erklärung ist die konsolidierte Erklärung zu den wichtigsten
							negativen Auswirkungen auf Nachhaltigkeitsfaktoren von Storton
							Fund Management Ltd. Diese Erklärung zu den wichtigsten negativen
							Auswirkungen auf Nachhaltigkeitsfaktoren deckt den
							Referenzzeitraum vom 1. Januar 2023 bis zum 31. Dezember 2023 ab.
						</p>
						<p style={{ marginTop: "20px" }}>
							Storton Fund Management Ltd [LEI S84500SSSA540457B545] considère
							les principaux impacts négatifs de ses décisions d'investissement
							sur les facteurs de durabilité. Le présent rapport est le rapport
							consolidé sur les principaux impacts négatifs sur les facteurs de
							durabilité de Storton Fund Management Ltd. Cette déclaration sur
							les principaux impacts négatifs sur les facteurs de durabilité
							couvre la période de référence du 1er janvier 2023 au 31 décembre
							2023.
						</p>
						<p
							style={{
								marginTop: "20px",
								background: "rgb(248, 249, 250)",
								padding: "10px 0px",
							}}>
							Storton Fund Management Ltd [LEI S84500SSSA540457B545] considera
							los principales impactos adversos de sus decisiones de inversión
							en los factores de sostenibilidad. La presente declaración es la
							declaración consolidada sobre los principales impactos adversos en
							los factores de sostenibilidad de Storton Fund Management Ltd.
							Esta declaración sobre los principales impactos adversos en los
							factores de sostenibilidad cubre el período de referencia del 1 de
							enero de 2023 al 31 de diciembre de 2023.
						</p>
					</div>
					<div className={styles.tableBody}>
						<table cellSpacing={0}>
							<thead>
								<tr>
									<th
										colSpan={7}
										style={{ textAlign: "left" }}>
										Description of the principal adverse impacts on
										sustainability factors
									</th>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										Indicators applicable to investments in investee companies
									</th>
								</tr>

								<tr>
									<th colSpan={2}>Adverse sustainability indicator</th>
									<th>Metric</th>
									<th>Impact 2023</th>
									<th>Impact 2022</th>
									<th>Explanation</th>
									<th style={{ width: "120px", height: "auto" }}>
										Actions taken, and actions planned and targets set for the
										next reference period
									</th>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										CLIMATE AND OTHER ENVIRONMENT-RELATED INDICATORS
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td rowSpan={9}>Greenhouse gas emissions</td>
									<td rowSpan={4}>1. GHG emissions</td>
									<td>Scope 1 GHG emissions</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Scope 2 GHG emissions</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Scope 3 GHG emissions</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Total GHG emissions</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>2. Carbon footprint</td>
									<td>Carbon footprint</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>3. GHG intensity of investee companies</td>
									<td>GHG intensity of investee companies</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>
										4. Exposure to companies active in the fossil fuel sector{" "}
									</td>
									<td>
										Share of investments in companies active in the fossil fuel
										sector{" "}
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>
										5. Share of non-renewable energy consumption and production
									</td>
									<td>
										Share of non-renewable energy consumption and non-renewable
										energy production of investee companies from non-renewable
										energy sources compared to renewable energy sources,
										expressed as a percentage of total energy sources
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>
										6. Energy consumption intensity per high impact climate
										sector
									</td>
									<td>
										Energy consumption in GWh per million EUR of revenue of
										investee companies, per high impact climate sector
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Biodiversity</td>
									<td>
										7. Activities negatively affecting biodiversity-sensitive
										areas
									</td>
									<td>
										Share of investments in investee companies with
										sites/operations located in or near to biodiversity-
										sensitive areas where activities of those investee companies
										negatively affect those areas
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Water</td>
									<td>8. Emissions to water</td>
									<td>
										Tonnes of emissions to water generated by investee companies
										permillionEURinvested, expressed as a weighted average
									</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Waste</td>
									<td>9. Hazardous waste and radioactive waste ratio</td>
									<td>
										Tonnes of hazardous waste and radioactive waste generated by
										investee companies per million EUR invested, expressed as a
										weighted average
									</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										INDICATORS FOR SOCIAL AND EMPLOYEE, RESPECT FOR HUMAN
										RIGHTS, ANTI-CORRUPTION AND ANTI-BRIBERY MATTERS
									</th>
								</tr>
								<tr>
									<td rowSpan={5}>Social and employee matters</td>
									<td>
										10. Violations of UN Global Compact principles and
										Organisation for Economic Cooperation and Development (OECD)
										Guidelines for Multinational Enterprises
									</td>
									<td>
										Share of investments in investee companies that have been
										involved in violations of the UNGC principles or OECD
										Guidelines for Multinational Enterprises
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>
										11. Lack of processes and compliance mechanisms to monitor
										compliance with UN Global Compact principles and OECD
										Guidelines for Multinational Enterprises
									</td>
									<td>
										Share of investments in investee companies without policies
										to monitor compliance with the UNGC principles or OECD
										Guidelines for Multinational Enterprises or grievance
										/complaints handling mechanisms to address violations of the
										UNGC principles or OECD Guidelines for Multinational
										Enterprises
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>12. Unadjusted gender pay gap</td>
									<td>
										Average unadjusted gender pay gap of investee companies
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>13. Board gender diversity</td>
									<td>
										Average ratio of female to male board members in investee
										companies,expressedasa percentage of all board members
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>
										14. Exposure to controversial weapons (anti- personnel
										mines, cluster munitions, chemical weapons and biological
										weapons)
									</td>
									<td>
										Share of investments in investee companies involved in the
										manufacture or selling of controversial weapons
									</td>
									<td>0%</td>
									<td>0%</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										Indicators applicable to investments in sovereigns and
										supranationals
									</th>
								</tr>
								<tr>
									<td>Environmental</td>
									<td>15. GHG intensity</td>
									<td>GHG intensity of investee countries</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Social </td>
									<td>16. Investee countries subject to social violations</td>
									<td>
										Number of investee countries subject to social violations
										(absolute number and relative number divided by all investee
										countries), as referred to in international treaties and
										conventions, United Nations principles and, where
										applicable, national law
									</td>
									<td>0</td>
									<td>0</td>
									<td>N/A</td>
									<td>N/A</td>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										Indicators applicable to investments in real estate assets
									</th>
								</tr>
								<tr>
									<td>Fossil fuels</td>
									<td>
										17. Exposure to fossil fuels through real estate assets
									</td>
									<td>
										Share of investments in real estate assets involved in the
										extraction, storage, transport or manufacture of fossil
										fuels
									</td>
									<td>0%</td>
									<td>N/A</td>
									<td>
										LRC does not own assets involved in the extraction, storage,
										transport or manufacture of fossil fuels.
									</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Energy efficiency</td>
									<td>18. Exposure to energy-inefficient real estate assets</td>
									<td>
										Share of investments in energy- inefficient real estate
										assets
									</td>
									<td>83%</td>
									<td>N/A</td>
									<td>
										This indicator has been calculated in accordance with the
										relevant formula using EPC/BER certificates and year end
										2023 asset valuations.
									</td>
									<td>
										We have set a target of improving the EPC scores of 5% of
										our assets per annum from 2024 onwards.
									</td>
								</tr>
								<tr>
									<th
										colSpan={7}
										style={{ padding: "20px 4px" }}>
										Other indicators for principal adverse impacts on
										sustainability factors
									</th>
								</tr>
								<tr>
									<td rowSpan={4}>Greenhouse gas emissions</td>
									<td rowSpan={4}>19. GHG emissionss</td>
									<td>Scope 1 GHG emissions generated by real estate assets</td>
									<td>28.37 tCO2e</td>
									<td>N/A</td>
									<td rowSpan={4}>
										We used 3rd party ESG specialists to assess and compile our
										2023 GHG emissions data.
									</td>
									<td rowSpan={4}>
										As this was the first time we had compiled our annual GHG
										emissions we are concentrating on refining our data
										collection systems whilst also reviewing the feasability of
										various GHG reduction initiatives.
									</td>
								</tr>
								<tr>
									<td>Scope 2 GHG emissions generated by real estate assets</td>
									<td>4007.76 tCO2e</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Scope 3 GHG emissions generated by real estate assets</td>
									<td>15,778.44 tCO2e</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Total GHG emissions generated by real estate assets</td>
									<td>19,814.56 tCO2e</td>
									<td>N/A</td>
								</tr>
								<tr>
									<td>Waste</td>
									<td>20. Waste production in operations</td>
									<td>
										Share of real estate assets not equipped with facilities for
										waste sorting and not covered by a waste recovery or
										recycling contract
									</td>
									<td>20%</td>
									<td>N/A</td>
									<td>
										Calculated on an asset by asset basis and then compiled
									</td>
									<td>
										For 2024, assess the possibility of implementing recycling
										where not already present
									</td>
								</tr>
								<tr>
									<td>Biodiversity</td>
									<td>21. Land artificialisation</td>
									<td>
										Share of non-vegetated surface area (surfaces that have not
										been vegetated in ground, as well as on roofs, terraces and
										walls) compared to the total surface area of the plots of
										all assets
									</td>
									<td>92%</td>
									<td>N/A</td>
									<td>
										Calculated on an asset by asset basis and then compiled
									</td>
									<td>
										For 2024, assess the possibility of increasing the share of
										vegetated surface area.
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div style={{ marginTop: "24px" }}>
						<h2>
							Description of policies to identify and prioritise principal
							adverse impacts on sustainability factors
						</h2>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "10px",
							}}>
							<p>
								LRC has a Responsible Investment Policy that was initially
								drafted in 2023 and approved in 2024, which outlines our
								responsible investment principles and sets out how these are to
								be incorporated into our requirements for investment activities
								and ownership practices. This policy is reviewed and approved at
								least annually.
							</p>
							<p>
								addition, we have implemented various policies and procedures
								including risk matrices/models to manage principal adverse
								impacts on an ongoing basis. We have identified specific
								principal adverse impact indicators which align with our
								responsible investment.
							</p>
							<p>
								We report on the mandatory indicators applicable to investments
								in real estate assets in Table 1 in Annex I Supplementing
								Regulation (EU) 2019/2088 of the European Parliament and of the
								Council. We also report on three additional climate and other
								environment-related indicators applicable to investments in real
								estate assets from Table 2 in Annex I supplementing Regulation
								(EU) 2019/2088 of the European Parliament and of the Council.
								The impact on the mandatory and additional indicators is
								reported by collecting and aggregating data from the real estate
								investments in our portfolio.
							</p>
							<p>
								We do not report on additional indicators for social and
								employee, respect for human rights, anti-corruption and
								anti-bribery matters in Table 3 in Annex I supplementing
								Regulation (EU) 2019/2088 of the European Parliament and of the
								Council as there are no indicators applicable to investments in
								real estate assets.
							</p>

							<p>
								QWe incorporate ESG aspects into the investment life cycle from
								the earliest stages of asset identification, through
								acquisition, into holding and then to disposal. All prospective
								acquisitions are subject to a comprehensive due diligence
								process including evaluation of technical and environmental
								performance to identify potential climate and ESG-related risks.
							</p>
							<p>
								Ǫuantifying and assessing our principal adverse impacts is
								dependent on data availability and quality. We rely on multiple
								sources to collect data on impacts.
							</p>
							<ul style={{ listStyle: "inside" }}>
								<li>
									Effects on energy efficiency are, when available, calculated
									on actual consumption. Where actual data is not available, the
									data is based on calculated estimates.
								</li>
								<li>
									To use actual data, this needs to be provided in a timely and
									accurate manner.
								</li>
								<li>
									We are continually striving to improve our data collection
									systems.
								</li>
							</ul>
							<h2 style={{ marginTop: "24px" }}>
								Best efforts used to obtain information relating to Scope 2
								emissions
							</h2>
							<p>
								For the impacts related to “Scope 2 GHG emissions” the data for
								several real estate investments has been partially estimated by
								making reasonable assumptions for one or more time periods. Our
								ESG data disclosure is continually improving and our aim is to
								continually improve the accuracy of our data and to reduce any
								associated margin of error.
							</p>
							<h2 style={{ marginTop: "24px" }}>Engagement policies</h2>
							<p>
								Engagement of our tenants, suppliers and service providers. We
								recognize the need to improve our communication and interaction
								with tenants and in 2024 we will conduct our first tenant
								survey. This survey will include several specific ESG related
								queries to help us better understand our tenants ESG aspirations
								and this feedback, once analysed, will help guide future
								initiatives.
							</p>
							<p>
								We also endeavour to provide our tenants with feedback on how
								they can improve their sustainability performance.
							</p>
							<p>
								Equally we also aim for a behavioural change amongst our
								stakeholders and business partners with whom we actively engage
								and promote ESG messages to and solicit feedback from.
							</p>
							<p>
								<b>Engagement of our staff.</b> We recognize the need to improve
								our communication and interaction with colleagues and in early
								2024 we conducted our first tenant survey. This survey will
								included several specific ESG related queries to help us better
								understand our colleagues ESG aspirations and this feedback,
								once analysed, will help guide future initiatives.
							</p>
							<h2 style={{ marginTop: "24px" }}>
								References to international standards
							</h2>
							<p>We submitted an application to UNPri in early 2024.</p>
							<p>
								Our Scope 1, 2, and 3 emissions were calculated in line with the
								GHG protocol.
							</p>
							<p>
								Our Risk Framework was drawn up, taking into account TCFD
								principles from its inception. We are assessing various other
								standards as to their suitability (GRESB and INRev).
							</p>
							<h2 style={{ marginTop: "24px" }}>Historical comparison</h2>
							<p>
								Since data for our principal adverse sustainability impacts is
								not available prior to 2023, this section is not applicable. A
								historical comparison of the period reported on with the
								preceding period will be included in the 2024 disclosure.
							</p>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}
